var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reports-sidebar-container scroll-fire-fox" },
    _vm._l(_vm.menuItemsAvailable, function(menuItem) {
      return _c("home-accordion", {
        key: menuItem.name,
        attrs: { label: menuItem.name },
        scopedSlots: _vm._u(
          [
            {
              key: "accordionBodyContent",
              fn: function() {
                return _vm._l(menuItem.submenu, function(submenuItem) {
                  return _vm.isSuperAdmin || !submenuItem.dev
                    ? _c("sidebar-button", {
                        key: submenuItem.name,
                        attrs: { item: submenuItem, selected: _vm.selected },
                        on: { toggle: _vm.toggleSelected }
                      })
                    : _vm._e()
                })
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f25ec8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f25ec8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/Sidebar/ReportsSidebar.vue
// module id = null
// module chunks = 